export default {
  SET_SELECTED_COMPANY: 'setSelectedCompany',
  SET_COMPANIES: 'setCompanies',
  SET_FIELD_TENANTS: 'setFieldTenants',
  SET_INACTIVE_FILTER_VAL: 'setInactiveFilterVal',
}